import React from 'react'
import { Field } from 'redux-form'
import { pt, buildPropTypes } from 'common-data/proptypehelpers'
import { FieldLayoutBox } from './FieldLayoutBox'
import { FieldValueFormatter, FieldValueParser } from './FieldValueConverters'
import { Input } from 'reactstrap'
import { DebounceInput } from 'react-debounce-input'

class DateTimeBoxClass extends React.Component {
  static propTypes = buildPropTypes([

  ], {
    type: pt.string
  })
  render () {
    const { type, debounceProps, ...rest } = this.props
    var inputType = type || 'datetime-local'
    return (
      <FieldLayoutBox {...rest}>
        {({ showError, value, onChange, name, placeHolder, loading, readonly, testId, onBlur }) => {
          if (readonly) {
            return <Input data-tid={testId} type={inputType} readOnly name={`view${name}`} id={`view${name}`} value={value} />
          } else {
            if (debounceProps) {
              return <DebounceInput
                className='form-control'
                minLength={debounceProps.minLength}
                debounceTimeout={debounceProps.debounceTimeout || 300}
                invalid={showError}
                name={`datetime${name}`}
                id={`datetime${name}`}
                placeholder={placeHolder}
                onChange={this.onChange.bind(this)}
                value={value} />
            } else {
              return <Input data-tid={testId} type={inputType} invalid={showError} name={`datetime${name}`} id={`datetime${name}`} placeholder={placeHolder} onChange={onChange} value={value} onBlur={onBlur} />
            }
          }
        }}
      </FieldLayoutBox>
    )
  }
};

export const DateTimeBox = ({ parse, format, fieldType, ...rest }) => { return <Field parse={fieldType ? FieldValueParser(fieldType) : parse} format={fieldType ? FieldValueFormatter(fieldType) : format} {...rest} component={DateTimeBoxClass} /> } // eslint-disable-line
export default DateTimeBox
